import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Avisa que el backend rechazo una accion con `409 GOAL_ARCHIVED` (HU 12.4): el objetivo
 * se archivo por cambio de mapa mientras el usuario lo tenia abierto.
 * Lo emite `HttpErrorInterceptor`; la ruta de crecimiento lo escucha para recargar.
 */
@Injectable({
  providedIn: 'root',
})
export class GoalArchivedNotifierService {
  private readonly goalArchivedSubject = new Subject<string>();

  /** Emite el `message` que devolvio el backend. */
  readonly goalArchived$: Observable<string> = this.goalArchivedSubject.asObservable();

  notify(message: string): void {
    this.goalArchivedSubject.next(message);
  }
}
